import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  COOKIE_CONSENT_ACCEPTED,
  COOKIE_CONSENT_REJECTED,
  getCookieConsentStatus,
  setCookieConsentStatus,
} from "../utils/analytics";

function shouldShowBanner() {
  if (typeof window === "undefined") {
    return false;
  }
  return !getCookieConsentStatus();
}

export default function CookieBanner() {
  const [visible, setVisible] = useState(shouldShowBanner);

  useEffect(() => {
    document.body.classList.toggle("has-cookie-banner", visible);
    return () => {
      document.body.classList.remove("has-cookie-banner");
    };
  }, [visible]);

  function acceptCookies() {
    setCookieConsentStatus(COOKIE_CONSENT_ACCEPTED);
    setVisible(false);
  }

  function rejectCookies() {
    setCookieConsentStatus(COOKIE_CONSENT_REJECTED);
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-label="Согласие на cookie">
      <div className="cookie-banner__panel">
        <div className="cookie-banner__inner">
          <p className="cookie-banner__text">
            Мы используем обязательные cookie для работы сайта. Аналитические cookie Google Analytics и Яндекс.Метрики
            помогают понимать, как используют сайт, и включаются только после вашего согласия.{" "}
            <Link to="/privacy-policy" className="cookie-banner__link">
              Политика конфиденциальности
            </Link>
          </p>
          <div className="cookie-banner__actions">
            <button className="btn-outline" type="button" onClick={rejectCookies}>Отказаться</button>
            <button className="btn-primary" type="button" onClick={acceptCookies}>Принять</button>
          </div>
        </div>
      </div>
    </div>
  );
}
